/* ==========================================================================
   md-ui.js — מכון אורטופדי מדליה · שכבת ההתנהגות היחידה של האתר
   ‎גרסה 3.0 · 27.08.2026
   ‎‏~1.4KB לא דחוס. defer. אפס תלויות.

   ‎שלוש משימות בלבד:
   ‎  1. חשיפה בגלילה (IntersectionObserver יחיד, stagger בין אחים)
   ‎  2. הופעת ה-hero (חשיפת מילים ב-H1)
   ‎  3. פס הפעולה הדביק במובייל — נכנס אחרי שה-hero יצא מהמסך

   ‎⚠️ ברירת המחדל היא "הכול גלוי". המחלקה md-anim. מתווספת ל-html
   ‎  רק כשיש IntersectionObserver ואין prefers-reduced-motion.
   ‎  אם הקובץ לא נטען / JS חסום — העמוד מוצג במלואו. אין מצב
   ‎  שבו טקסט נעלם בגלל אנימציה.
   ‎⚠️ אפס קריאות רשת, אפס מדידות layout בזמן גלילה (רק IO).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__mdUI) return;
  window.__mdUI = 1;

  var root = document.documentElement;
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canAnimate = !calm && 'IntersectionObserver' in window;

  function revealAll(nodes) {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('md-in');
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-md-reveal]');
    var hero = document.querySelector('.md-hero-sec');
    var bar = document.querySelector('[data-md-stickybar]');

    /* ---- 1+2 · חשיפה ---- */
    if (!canAnimate) {
      revealAll(nodes);
      if (hero) hero.classList.add('md-hero--in');
    } else {
      root.classList.add('md-anim');

      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('md-in');
            io.unobserve(entries[i].target);
          }
        }
      }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });

      for (var j = 0; j < nodes.length; j++) {
        /* stagger לפי מיקום בין אחים — 70ms, מקסימום 5 מדרגות */
        var step = 0, prev = nodes[j];
        while ((prev = prev.previousElementSibling)) {
          if (prev.hasAttribute('data-md-reveal')) step++;
        }
        if (step > 5) step = 5;
        nodes[j].style.setProperty('--md-rd', step * 70 + 'ms');
        io.observe(nodes[j]);
      }

      /* ה-hero לא מחכה לגלילה — הוא כבר במסך */
      if (hero) hero.classList.add('md-hero--in');

      /* ---- רשת ביטחון ----
         ‎אם מסיבה כלשהי ה-IntersectionObserver לא נורה (לשונית ברקע
         ‎שלא מרנדרת פריימים, דפדפן שמעכב, באג עתידי) — אחרי 2.4 שניות
         ‎הכול נחשף בכוח. אין תרחיש שבו טקסט נשאר בלתי נראה. */
      setTimeout(function () {
        revealAll(document.querySelectorAll('[data-md-reveal]:not(.md-in)'));
        /* ה-H1 הוא ה-LCP. אם אנימציית ה-CSS לא רצה (לשונית ברקע שלא
           מרנדרת) — כאן היא מבוטלת לגמרי והמילים מוצגות. */
        root.classList.add('md-words-done');
      }, 2400);
    }

    /* ---- 3 · פס דביק במובייל ---- */
    if (bar) {
      if (!hero) {
        bar.classList.add('md-stickybar--on');
      } else {
        var sync = function () {
          bar.classList.toggle('md-stickybar--on', hero.getBoundingClientRect().bottom < 8);
        };
        /* IntersectionObserver כמנוע ראשי (אפס קריאות layout),
           ומאזין גלילה ממותן כגיבוי — כדי שהפס יעבוד גם כשהדפדפן
           לא מרנדר פריימים ולכן ה-IO לא נורה. */
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(sync, { threshold: 0 }).observe(hero);
        }
        var last = 0;
        window.addEventListener('scroll', function () {
          var now = Date.now();
          if (now - last < 120) return;
          last = now;
          sync();
        }, { passive: true });
        sync();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ── קליפי וידאו (הירו + md-insole) ───────────────────────────
   ‎הווידאו על autoplay רגיל ב-HTML. הבלוק הזה קיים רק כדי לטפל
   ‎במקרים שבהם הדפדפן לא ינגן לבד:

   1. prefers-reduced-motion — עוצר ומציג פקדים. חובה נגישות.
   2. חסימת ניגון אוטומטי — קודם מנסים להתחיל בנגיעה הראשונה
      ‎של המשתמש בעמוד, ורק אם גם זה נכשל מציגים כפתור הפעלה.

   ‎עודכן 9.9 אחרי שבמובייל הופיע כפתור פליי במקום ניגון אוטומטי.
   ‎הסיבה: קראנו ל-play() יזום מיד עם טעינת העמוד. ב-iOS קריאה
   ‎יזומה בלי מחווה של המשתמש נדחית גם כשתכונת autoplay עצמה
   ‎הייתה מנגנת בסדר גמור, וה-catch שלנו הדליק פקדים ובכך ביטל
   ‎את מה שהדפדפן ממילא עמד לעשות. עכשיו נותנים לתכונה הזדמנות
   ‎ראשונה, ורק אם היא לא נורתה מתערבים.
   ───────────────────────────────────────────────────────────── */
(function () {
  var vids = [].slice.call(document.querySelectorAll('video[data-md-clip]'));
  if (!vids.length) return;

  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function manual(v) {
    v.setAttribute('controls', '');
    v.removeAttribute('loop');
  }

  /* ‎נגיעה אחת כלשהי בעמוד היא מחווה מספקת. עדיף מלדרוש מהמשתמש
     ‎לאתר כפתור פליי קטן בתוך הכרטיס. */
  function armGesture(v) {
    var evs = ['touchstart', 'pointerdown', 'keydown', 'scroll'];
    function off() {
      evs.forEach(function (e) { document.removeEventListener(e, go); });
    }
    function go() {
      var p = v.play();
      if (p && p.then) {
        p.then(function () { v.removeAttribute('controls'); off(); })
         .catch(function () {});
      } else {
        off();
      }
    }
    evs.forEach(function (e) {
      document.addEventListener(e, go, { passive: true });
    });
  }

  vids.forEach(function (v) {
    if (calm) {
      v.autoplay = false;
      try { v.pause(); } catch (e) {}
      manual(v);
      return;
    }

    var started = false;
    v.addEventListener('playing', function () {
      started = true;
      v.removeAttribute('controls');
    });

    /* ‎שלב 1 — לא נוגעים. נותנים לתכונת autoplay לעשות את שלה. */

    /* ‎שלב 2 — אם אחרי שנייה וחצי עוד לא זז כלום, מנסים ידנית. */
    setTimeout(function () {
      if (started) return;
      var p = v.play();
      if (p && p.catch) {
        p.catch(function () {
          if (!started) { manual(v); armGesture(v); }
        });
      }
    }, 1500);

    /* ‎שלב 3 — רשת ביטחון לדפדפנים ש-play() בהם לא מחזיר Promise,
       ‎ולמקרים כמו מצב חיסכון בסוללה ב-iOS שחוסם ניגון אוטומטי
       ‎לחלוטין ואי אפשר לעקוף אותו. */
    setTimeout(function () {
      if (!started && v.paused) { manual(v); armGesture(v); }
    }, 9000);
  });
})();
